export default "__VITE_ASSET__ChzvzsJD__"